import { render } from "./AnimatedGradientTexture.vue?vue&type=template&id=21c444e6&scoped=true"
const script = {}

import "./AnimatedGradientTexture.vue?vue&type=style&index=0&id=21c444e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c444e6"]])

export default __exports__